// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const SupplierCodeService = {};

SupplierCodeService.getSupplierList = function (userInput) {
  return lossClient({
    url: "/Supplier/suppliers?pageSize=1000&pageIndex=0",
    method: "get",
  });
};

export default SupplierCodeService;
